module.exports = __webpack_public_path__ + "img/maruteru_logo.9eb7010d.png";